/* eslint-disable no-unused-vars */
import React from "react";
//components:
import SImpleDropDown from "../../components/simpleDropDown/SimpleDropDown";
//classes:
import { KEYS } from "../../classes/keywords";
import { lang } from "../../classes/lang";
import { go } from "../../classes/routesLazy";
import { useSelector } from "react-redux";
import ImageCached from "../../classes/cache";
const LangSel = () => {
	const langO = useSelector((state) => state.lang);
	const langRoute = useSelector((state) => state.langRoute);
	if (!langO) return null;
	const selectedLang = lang.getSelectedSync({ lang: langO, langRoute: langRoute });
	const onLangSelect = (locale) => {
		// lang.storeLocale(locale);
		let str = typeof window === "undefined" ? "" : window.location.pathname;
		if (str.charAt(3) === "/") str = str.substring(4);
		else if (str.length === 3) str = "";
		// go(str);
		return `/${locale}/${str}`;
	};
	const getImg = (name) => {
		return <ImageCached storageName="flag" className="imgFlag" url={`/assets/flags/${name}.png`} alt="" params={{}} />;
	};
	return (
		<SImpleDropDown
			onMouseLeave={() => [document.getElementById("root").click()]}
			render={true}
			down={false}
			// className="calendarDropDown"
			// headerClassname= "calendarHeaderDropDown"
			headerClassname="diceBtn blue ddHeader p5_left_i"
			headerStyle={{ backgroundColor: "transparent", padding: 0, border: "none" }}
			header={<div>{getImg(selectedLang)}</div>}
			style={{ width: "unset", backgroundColor: "transparent" }}
			content={
				<div className="btns">
					{KEYS.filter((el) => el !== selectedLang).map((el, i) => (
						<a
							onClick={() => (window.location.href = "")}
							style={{ display: "flex", alignItems: "center", gap: "8px", padding: "5px 0px" }}
							href={`${onLangSelect(el)}`}
							// onClick={() => [document.getElementById("root").click(), onLangSelect(el)]}
							className="btnDefault"
							key={i}
						>
							{getImg(el)}
							<b>{el}</b>
						</a>
					))}
				</div>
			}
			showArrow={true}
		/>
	);
};
export default LangSel;
